import { Component } from '@angular/core';

@Component({
	selector: 'empty-view',
	template: '<div ui-view></div>'
})
export class EmptyViewComponent {

}
